export default class Constants {
    static get API_BASE_URL() { return window.API_BASE_URL }
    static get BASE_URL() { return window.BASE_URL}
    static get DOC_API_URL() { return window.DOC_API_URL}
    static get DOC_DOWNLOAD_URL() { return window.DOC_DOWNLOAD_URL}
    static get USER_ID() { return window.USER_ID}
    static get COMPANY_TYPE() { return window.COMPANY_TYPE} // 1 = lab/ 2 = tarahi-nezarat / 3=ejra
}